export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: '/',
  HOME: '/home',
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  APPOINTMENTS: '/appointments',
  IN_PERSON_CONSULTATION: '/book-in-person',
  FAQ: '/FAQ',
  PERSONAL_INFORMATION: '/personal-information',
  CONTACT_US: '/contact-us',
  PRIVACY_POLICY: '/privacy-policy',
  TOS: '/terms-of-service',
  SIGN_UP: '/sign-in',
  VIRTUAL_CONSULTATION: '/book-virtual-consult',
  LINKED_CENTRES: '/linked-centres',
};
